import {
  SchemaDefsOrReferences,
  findAllDefs,
  normalizeDefs,
} from "@noya-app/noya-schemas";
import { Static, TSchema } from "@sinclair/typebox";
import { Cast, Create } from "@sinclair/typebox/value";

export function createValue<T extends TSchema>(
  schema: T,
  defs?: SchemaDefsOrReferences
): Static<T> {
  if (!defs) {
    defs = findAllDefs(schema);
  }

  return Create(schema, normalizeDefs(defs));
}

export function castValue<T extends TSchema>(
  schema: T,
  defs: SchemaDefsOrReferences | undefined,
  value: unknown
): Static<T> {
  if (!defs) {
    defs = findAllDefs(schema);
  }

  return Cast(schema, normalizeDefs(defs), value);
}
